module.exports = __webpack_public_path__ + "assets/76491c73b8b060e9d5210df105b98a78.png";